module.exports = __webpack_public_path__ + "static/media/pub.6e485601.jpg";